import React from 'react';
import CloseIcon from './img/close-icon.svg';
import * as S from './SideModal.style';
export const SideModal = ({ show, children, close }) => {
    return (React.createElement(S.ModalContent, { toogleFilter: show },
        React.createElement(S.ModalWrapper, null,
            React.createElement(S.CloseModal, { onClick: () => close() },
                React.createElement(S.CloseIcon, { src: CloseIcon, alt: 'Fechar', width: '44', height: '44' }),
                "Fechar"),
            children)));
};
//# sourceMappingURL=SideModal.js.map